import { FinanceScreen } from './FinanceScreen.jsx';

export default {
  path: '/finance',
  element: <FinanceScreen />,
  protected: true,
  permission: 'finance.view',
  standalone: false,
  sidebar: { label: 'المصاريف والإيرادات', icon: 'finance', group: 'finance', order: 81 }
};
